import React, { useContext } from "react";
import { TypeContext } from "../../context/TypeContext";

// type Props = ReturnType<typeof useFilterListProps>;

export const FiltersButton: React.FC<any> = ({ option, value, handleChange }) => {
  const checked: boolean = value[option.key] || option.key === value;
  const displayValue: string = option.key?.toString();
  const typeContext = useContext(TypeContext);

  const classes: string =
    typeContext === "search"
      ? `after:content-['→'] cursor-pointer after:ml-0.5 after:text-xs uppercase h-auto leading-tight hover:text-black ${
          checked ? "text-black" : ""
        }`
      : `btn btn--small js-no-transition ${checked ? "checked" : ""}`;

  return (
    <li className="tag tag--remove">
      <label className={classes}>
        <input
          type="checkbox"
          className="hidden"
          key={option.key?.toString()}
          value={option.key}
          checked={checked}
          onChange={handleChange}
        />
        {displayValue}
      </label>
    </li>
  );
};
